import { useGetPublicDataSources } from '@upright/ui/api/model/input/data-sources/hooks';
import { pickPreferredDataPoint } from '../../../../../common/model/data-point-pickers';
import { CompanyEmployeeCount } from '../../../../../common/model/input/companies/data-points/employee-counts/types';
import { useCompany } from '@upright/ui/api/model/input/companies';
import { useDefaultCompanyResult } from './use-default-company-result';

export function useEmployeeCount(companyId: string): CompanyEmployeeCount | undefined {
  const { data: company } = useCompany(companyId);
  const { data: publicDataSources } = useGetPublicDataSources();
  const modelResult = useDefaultCompanyResult(companyId);

  if (!company || !publicDataSources) {
    return undefined;
  }
  return pickPreferredDataPoint(company.employeeCounts, publicDataSources, modelResult);
}
